<template>
  <div :class="['layout', { 'layout--no-sidebar': hideSidebar, 'mobile-nav-open': mobileNavOpen }]">
    <SidebarNav
      v-if="!hideSidebar"
      :open="mobileNavOpen"
    />
    <main
      class="page page-wrapper"
      role="main"
      data-check-hash="b85f20bb7f1b2bdfa4ddd28e2ec322c86cedea8f"
    >
      <TopNav
        v-if="!hideSidebar"
        :sidebar-open="mobileNavOpen"
        @toggle-sidebar="toggleMobileNav"
      />
      <router-view />
    </main>
    <PrimeToast position="top-right" />
    <div
      v-if="mobileNavOpen"
      class="backdrop"
      @click="toggleMobileNav(false)"
    />
  </div>
</template>

<script>
import SidebarNav from './components/SidebarNav.vue';
import TopNav from './components/layout/TopNav.vue';

export default {
  name: 'App',
  components: {SidebarNav, TopNav},
  data() {
    return {
      mobileNavOpen: false
    };
  },
  computed: {
    hideSidebar() {
      const hiddenRoutes = [
        'Login',
        'ForgotPassword',
        'ResetPassword',
        'Impressum',
        'Datenschutz',
        'Maintenance',
        'NotFound',
        'SchoolEnrollment'
      ];
      return hiddenRoutes.includes(this.$route.name);
    }
  },
  watch: {
    $route() {
      // Bei Navigation das mobile Menü schließen
      this.mobileNavOpen = false;
    }
  },
  mounted() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.handleResize, {passive: true});
    }
  },
  beforeUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.handleResize, {passive: true});
    }
  },
  methods: {
    toggleMobileNav(next) {
      if (typeof next === 'boolean') this.mobileNavOpen = next;
      else this.mobileNavOpen = !this.mobileNavOpen;
    },
    handleResize() {
      if (typeof window !== 'undefined' && window.innerWidth >= 768 && this.mobileNavOpen) {
        this.mobileNavOpen = false;
      }
    }
  }
};
</script>

<style>
/* Basisstilistik kommt aus styles/base.css */
html, body, #app {
  height: 100%;
}

body {
  margin: 0;
}

/* App-weites Dropdown-Styling (wie in Dialogen) */
select {
  height: 36px;
  padding: 6px 8px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--surface);
  color: var(--text);
  font: inherit;
  line-height: 1.4;
  outline: none;
  /* Ein konsistentes Look&Feel unabhängig vom UA */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

select:hover:not(:disabled) {
  border-color: var(--border-strong);
}

select:focus,
select:focus-visible {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px var(--focus);
  outline: none;
}

select:disabled {
  opacity: .65;
  cursor: not-allowed;
}

@media (max-width: 1366px) {
  .page.page-wrapper {
    position: absolute;
    width: 100%;
    min-width: 100%;
    max-width: 100%;
  }
}

/* Overlay hinter dem mobilen Drawer */
.backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, .35);
  z-index: 900;
}
</style>
